"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectIsMaxUnhiddenCameras = exports.selectIsMaxCamerasOn = exports.selectActiveCameras = void 0;
var _reselect = require("reselect");
var _constants = require("@studio/constants");
var _broadcastSourcesSelector = require("./broadcastSourcesSelector");
function selectAttendeeCameraStatus(state) {
  return state.attendeeCameraStatus;
}
var selectActiveCameras = exports.selectActiveCameras = (0, _reselect.createSelector)(_broadcastSourcesSelector.selectPresenterSources, selectAttendeeCameraStatus, function (presenterSources, attendeeCameraStatus) {
  return presenterSources.filter(function (source) {
    return attendeeCameraStatus[source.value];
  });
});
var selectIsMaxUnhiddenCameras = exports.selectIsMaxUnhiddenCameras = (0, _reselect.createSelector)(_broadcastSourcesSelector.selectPresenterSources, selectAttendeeCameraStatus, function (presenterSources, attendeeCameraStatus) {
  var unhiddenCameras = presenterSources.filter(function (source) {
    return attendeeCameraStatus[source.value] && !source.hidden;
  });
  return unhiddenCameras.length >= _constants.CAMERA_PRESENTER_LIMIT;
});
var selectIsMaxCamerasOn = exports.selectIsMaxCamerasOn = (0, _reselect.createSelector)(selectActiveCameras, function (activeCameras) {
  return activeCameras.length >= _constants.CAMERA_PRESENTER_LIMIT;
});